export const localStorageWorkspaceId = 'workspaceId'

export const refreshWorkspaceId = 'refreshWorkspaceId'

export function getWorkspaceIdFromLocalStorage(): string | null | undefined {
  return window?.localStorage?.getItem(localStorageWorkspaceId)
}
